<template>
  <div class="app-info-search">
    <div>
      <Table
        ref="table"
        stripe
        :data="datas"
        :columns="dataCol"
        @on-select="onSelect"
        @on-select-cancel="onSelectCancel"
        @on-select-all="onSelectAll"
        @on-select-all-cancel="onSelectAllCancel"
        no-data-text="暂无数据"
      >
        <!-- @click="seeVideo(row)" -->
        <template slot-scope="{ row, index }" slot="name">
          <CommonTip iconName="icon_shipinziyuanguanli" :status="row.status=='ON'?1:0" :text="row.name" />
          <!-- <span class="fontcursor">{{ row.name }}</span> -->
        </template>
        <template slot-scope="{ row, index }" slot="services">
          <div v-if="row.dataList && row.dataList.length > 0">
            <!-- @click="clickBtn(item, row)" -->
            <Button
              class="mr-8 colBtn"
              shape="circle"
              size="small"
              v-for="(item, index) in row.dataList"
              :key="index"
            >
              <img :src="item.companyLogo" alt class="imgClass" />
              <Tooltip
                transfer
                placement="top"
                v-if="item.serviceName.length > 5"
                :content="item.serviceName"
              >
                <span class="ml-4 fontthreedark">
                  {{ item.serviceName.substring(0, 5) + "..." }}
                </span>
              </Tooltip>
              <span v-else class="ml-4 fontthreedark">
                {{ item.serviceName }}
              </span>
            </Button>
            <Dropdown transfer placement="bottom-start">
              <!-- 更多服务 -->
              <Button
                class="mr-8"
                shape="circle"
                size="small"
                v-if="row.moreList.length"
              >
                <i class="icon tsit icon_gengduofuwu fontblue"></i>
                <span style="top: 1px" class="ml-4 fontthreedark"
                  >+{{ row.moreList.length }}服务</span
                >
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, idx) in row.moreList" :key="idx">
                  <span>{{ item.serviceName }}</span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <p class="btn" v-else>-</p>
        </template>
      </Table>
    </div>
    <Row class="mt-16" type="flex" justify="end">
      <Page
        :total="totalCount"
        :page-size="pageSearch.pageSize"
        :page-size-opts="psize"
        :current="pageSearch.pageNum"
        @on-change="handlePage"
        @on-page-size-change="sizeChange"
        show-sizer
        show-total
        show-elevator
        placement="top"
        class-name="page"
      />
    </Row>
    <CameraDetail
      v-if="showDetail"
      :videoForm="videoForm"
      @close="showDetail = false"
    />
    <MarkModel
      v-if="showMark"
      :videoForm="videoForm"
      @close="
        showMark = false;
        closeMark();
      "
    />
  </div>
</template>
<script>
import { sipVideoSearch, appInfoSelectTreeSearch } from "@/api/app";
import CommonTip from "@/components/tip/common-tooltip";

export default {
  name: "",
  components: { CommonTip },
  props: {
    id: String,
    resourceIds: Set,
    showState: Boolean,
    totalNum: Number,
    groupId: String,
  },

  data() {
    return {
      totalCount: 0,
      datas: [],
      dataCol: [
        {
          title: "视频资源名称",
          slot: "name",
          tooltip: true,
          trigger: blur,
        },
        {
          title: "服务详情",
          slot: "services",
          tooltip: true,
        },
      ],
      pageSearch: {
        pageNum: 1,
        pageSize: 10,
      },
      tempArr: [], // 记录已经勾选的数据
      psize: [5, 10],
      videoForm: {},
      videoUrl: {},
      searchKey: "",
      showDetail: false, //查看视频
      showUrl: false, //查看视频地址
      appId: "",
      showMark: false,
    };
  },
  watch: {
    //解决当前页最后一条删除后，没有自动折页的问题
    totalCount() {
      const cPage = this.totalCount / this.pageSearch.pageSize;
      if (
        this.pageSearch.pageNum === cPage + 1 &&
        this.pageSearch.pageNum != 1
      ) {
        this.pageSearch.pageNum = this.pageSearch.pageNum - 1;
        this.getSearchList(); //获取列表数据
      }
    },
  },
  mounted() {
    //如果是查看，去掉多选框
    // if (this.id) this.dataCol.splice(0, 1);
  },
  watch: {
    //是否展示表格
    showState(value) {
      //更新默认选中id
      if (!value) this.tempArr = Array.from(this.resourceIds);
    },
  },
  created() {
    this.dialog = true;
    this.appId = this.$route.query.id;
  },
  methods: {
    /**
     * 删除时把选中状态传给后台
     * 如果删除资源，清除搜索时需要重新加载树列表
     */
    delVideoV2(row) {
      let data = {
        cameraIds: [row.id],
        catalogueIds: [],
      };
      delVideoV2(this.appId, data).then((res) => {
        this.$Message.success("删除成功");
        console.log(res, "删除数据");
        this.pageSearch.pageNum = 1;
        this.getSearchList();
        //点击了删除按钮，清除搜索后需要重新获取树列表
        this.$emit("update:isClearLoad", true);
        this.getVideoNum();
      });
    },
    /**
     * 参数1:服务信息
     * 参数2:视频信息
     */
    clickBtn(item, data) {
      console.log(item, data, "item----");
      let query = {
        applicationId: JSON.stringify(this.id),
        serviceId: item.serviceId,
        resourceId: JSON.stringify(data.id),
      };
      // this.query = query;
      openMark(query)
        .then((res) => {
          console.log(res, "开启标注");
          this.videoForm = res.data.data;
          if (item.serviceType == 18 || item.serviceType == 19) {
            this.videoForm.isPeople = true;
          } else {
            this.videoForm.isPeople = false;
          }
          this.videoForm.query = this.query;
          this.$set(this.videoForm, "title", data.name);
          console.log(this.videoForm, "form--");
          this.showMark = true;
        })
        .catch((err) => {
          console.log("打开失败===========");
        });
    },
    closeMark() {
      closeMark(this.query).then((res) => {
        console.log(res, "关闭标注");
      });
    },
    seeVideo(data) {
      let host = window.location.host;
      getVideoDetailV2(this.appId, { id: data.id, host: window.apiHost }).then(
        (res) => {
          console.log(res, "获取摄像头地址");
          this.showDetail = true;
          this.videoForm = res.data.data;
        }
      );
    },
    seeAddress(data) {
      console.log(data, "点击的节点");
      if (data.type) {
        getVideoDetailV2({ id: data.id }).then((res) => {
          console.log(res, "获取摄像头地址");
          this.showUrl = true;
          let json = res.data.data;
          this.videoUrl = {
            flv: json.flv,
            m3u8: json.m3u8,
            rtmp: json.rtmp,
            ws: json.ws,
          };
        });
      }
    },
    //选择某一项时触发
    onSelect(selection, row) {
      this.tempArr.push(row.id);
      this.datas.forEach((item) => {
        // 本页数据中找到该条勾选数据并添加属性_checked = true
        if (item.id === row.id) {
          item["_checked"] = true;
        }
      });
      this.$emit("setChecked", row.id, true);

      // 将该条数据添加到tempArr中
    },
    //取消某一项时触发
    onSelectCancel(selection, row) {
      this.$emit("setChecked", row.id, false);
      this.tempArr.forEach((item, index) => {
        // tempArr中找到该条数据并删除
        if (row.id === item) {
          this.tempArr.splice(index, 1);
        }
      });
    },
    onSelectAllCancel() {},
    //点击全选
    onSelectAll(selection) {
      selection.forEach((item) => {
        // 将本页全部勾选添加到tempArr中
        this.tempArr.push(item.id);
      });
      this.tempArr = Array.from(new Set(this.tempArr)); // 去重
    },
    handlePage(value) {
      this.pageSearch.pageNum = value;
      this.getSearchList();
    },
    sizeChange(value) {
      this.pageSearch.pageSize = value;
      this.getSearchList();
    },
    priview(row) {
      this.showDetail = true;
      this.videoForm = { id: row.id };
    },
    //设置表格选中
    handleTableChecked(datas) {
      this.tempArr.forEach((item) => {
        // 判断本页数据状态
        datas.forEach((e) => {
          if (item === e.id) {
            e["_checked"] = true;
          }
        });
      });
    },
    searchKay(name) {
      this.pageSearch.pageNum = 1;
      if (name) this.pageSearch.name = name;
      this.getSearchList();
    },
    //获取摄像头
    getSearchList() {
      if (this.id) this.getSipVideoSearch();
      else this.getselectedTreeSearch();
    },
    //树搜索
    getselectedTreeSearch() {
      console.log("树搜索");
      selectedTreeSearch(this.appId, this.pageSearch).then((res) => {
        console.log(res, "table--res");
        let data = res.data;
        this.setSearchList(data);
        //获取摄像头数量
      });
    },
    //获取摄像头数量
    getVideoNum() {
      getAppVideoNum(this.appId).then((res) => {
        console.log(res, "摄像头数量");
        this.$emit("update:totalNum", res.data.data);
      });
    },
    //详情搜索
    getSipVideoSearch() {
      let data = {
        ...this.pageSearch,
        groupId: this.groupId,
        appId: this.appId,
      };
      appInfoSelectTreeSearch(data).then((res) => {
        console.log(res, "详情搜索");
        let data = res.data.data;
        this.setSearchList(data);
      });
    },
    //获取数据
    setSearchList(data) {
      this.datas = data.list || [];
      this.totalCount = data.total;
      if (this.datas.length) {
        this.datas.forEach((item) => {
          // if (item.type == 1) {
            if (item.services && item.services.length > 3) {
              item.dataList = item.services.filter((x, index) => index < 2);
              item.moreList = item.services.filter((x, index) => index >= 2);
            } else {
              item.dataList = item.services;
              item.moreList = [];
            }
          // }
        });
      }
      console.log(this.datas, "this.datas--");
      this.handleTableChecked(this.datas);
    },
  },
};
</script>
<style lang="scss">
.app-info-search {
  .top {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .search-key {
      // padding: 0 12px;
      // margin-bottom: 12px;
      // width: 300px;
      // .ivu-input-icon {
      //   margin-right: 70px;
      // }
    }
    .num {
      height: 21px;
      align-self: center;
    }
  }
  .colBtn {
    span {
      position: relative;
      top: -2px;
    }
  }
  .ivu-btn-small {
    height: 25px;
  }
  .imgClass {
    width: 20px;
    height: 20px;
    position: relative;
    top: 3px;
    border-radius: 50%;
  }
  .priview {
    cursor: pointer;
    color: blue;
  }
  .selectResource {
    &-modal {
      .ivu-modal-body {
        min-height: 200px;
      }
      &-industry {
        .ivu-form-item-content {
          line-height: 24px;
        }
      }
    }
  }
}
</style>
